import { captureMessage } from '@sentry/browser';

export function getParameterByName(name: string) {
    // TODO: ZXY-1209 clean up if bug is fixed
    if (!window?.location?.href) {
        captureMessage('window.location.href is undefined');
    }
    const url = window.location.href;
    name = name.replace(/[[\]]/g, '\\$&');
    const regex = new RegExp(`[?&]${name}(=([^&#]*)|&|#|$)`);
    const results = regex.exec(url);
    if (!results) {
        return undefined;
    }
    if (!results[2]) {
        return '';
    }
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}
